import React, { useState } from 'react';
import apiClient from '../api/apiClient';
import '../components/blog/styles/NewsletterSignup.css';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validazione email
    if (!email || !email.includes('@')) {
      setError('Per favore, inserisci un indirizzo email valido.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Usa l'endpoint per l'iscrizione alla newsletter
      const response = await apiClient.post('/api/accounts/newsletter/subscribe/', { 
        email: email.trim(),
        // Potremmo specificare anche list_id se necessario 
      });

      setSuccess(true);
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.error || 'Si è verificato un errore. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newsletter-signup">
      {success ? (
        <div className="newsletter-success">
          <div className="success-icon">✓</div>
          <h4>Grazie per l'iscrizione!</h4>
          <p>Riceverai presto i nostri aggiornamenti.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="newsletter-form-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Il tuo indirizzo email"
              disabled={loading}
              className="newsletter-input"
            />
            <button 
              type="submit" 
              disabled={loading} 
              className="newsletter-button"
            >
              {loading ? 'Invio...' : 'Iscriviti'}
            </button>
          </div>
          {error && <p className="newsletter-error">{error}</p>}
        </form>
      )}
    </div>
  );
};

export default NewsletterSignup; 